export function formatMoney(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return `$${num.toFixed(2)}`;
}

export function formatUserRange(min, max) {
  if (min == null || max == null) return '—';
  return `${min} – ${max}`;
}

export function formatTierLabel(tierNumber) {
  return tierNumber != null ? `Tier #${tierNumber}` : '—';
}

export function hasFullActiveTierCoverage(tiers) {
  const active = (tiers || [])
    .filter((t) => t.isActive)
    .sort((a, b) => a.minAssociates - b.minAssociates);
  if (active.length < 2) return false;
  for (let i = 1; i < active.length; i += 1) {
    if (active[i].minAssociates !== active[i - 1].maxAssociates + 1) {
      return false;
    }
  }
  return true;
}
